<script lang="ts">
    class AltreInfo {
        smartWorkingTelelavoro: boolean;
        smartWorkingTelelavoroNote: string;
        smartWorkingTelelavoroOre: string;
        smartWorkingTelelavoroRequisiti: string;
        smartWorkingTelelavoroStrumenti: string;
        spogliatoiDocce: boolean;
        spogliatoiDocceNote: string;
        mensaAziendale: boolean;
        mensaAziendaleNote: string;
        asiloAziendale: boolean;
        asiloAziendaleNote: string;
        altriServizi: boolean;
        altriServiziNote: string;

        constructor(init?: AltreInfo) {
            Object.assign(this, init);
        }
    }

    export let data: AltreInfo = new AltreInfo();

    const properties = [
        { name: "Smart working/telelavoro", key: "smartWorkingTelelavoro", noteKey: "smartWorkingTelelavoroNote", type: "boolean" },
        { name: "Fino a quante ore/mezze giornate/giornate/percentuali di orario possono essere svolte in modalità smart working?", key: "smartWorkingTelelavoroOre", type: "string" },
        { name: "Quali sono i requisiti per cui possa essere svolta l'attività lavorativa in modalità smart?", key: "smartWorkingTelelavoroRequisiti", type: "string" },
        { name: "Vengono forniti in dotazione gli strumenti per svolgere lo smart working? (pc, telefono,ecc.)", key: "smartWorkingTelelavoroStrumenti", type: "string" },
        { name: "Spogliatoi e docce", key: "spogliatoiDocce", noteKey: "spogliatoiDocceNote", type: "boolean" },
        { name: "Mensa aziendale", key: "mensaAziendale", noteKey: "mensaAziendaleNote", type: "boolean" },
        { name: "Asilo aziendale", key: "asiloAziendale", noteKey: "asiloAziendaleNote", type: "boolean" },
        { name: "Altri servizi", key: "altriServizi", noteKey: "altriServiziNote", type: "boolean" },
    ];

    function isAnyFieldSet(): boolean {
        return properties.some((property) => data?.[property?.key]);
    }
</script>

<table class="w-full text-xs border border-black table-fixed">
    <thead>
        <tr>
            <th class="border border-black">Voce</th>
            <th class="border border-black">Valore</th>
            <th class="border border-black">Note</th>
        </tr>
    </thead>
    <tbody>
        {#each properties as property}
            <tr>
                <td class="text-center border border-black">{property?.name}</td>
                <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                    {#if property?.type === "boolean"}
                        {data?.[property?.key] !== undefined ? (data?.[property?.key] ? "Sì" : "No") : '-'}
                    {:else}
                        {data?.[property?.key] || '-'}
                    {/if}
                </td>
                <td class:bg-blue-100={!isAnyFieldSet()} class="text-center border border-black">
                    {data?.[property?.key] && data?.[property?.noteKey] ? data?.[property?.noteKey] : '-'}
                </td>
            </tr>
        {/each}
    </tbody>
</table>